module.exports = __webpack_public_path__ + "";